<template>
  <div style="width:100%; padding-top: 60px">
    <div style="position: fixed;background-color: white;top: 0px;z-index: 999;width: 100%;">
      <div style="text-align:center">
        <van-button type="info" size="small" style="margin-left: 3%;width: 15%;" @click="goBack">返回</van-button>
        <screenButton class="screenButton"></screenButton>
      </div>
    </div>

    <b-table class="bgc-dark" head-variant="dark" responsive bordered
             :items="items" :fields="fields1">
      <template v-slot:head()="scope">
        <div class="text-nowrap" style="text-align:center; vertical-align: middle;">
          {{ scope.label }}
        </div>
      </template>
      <template v-slot:cell(index)="data">
        {{ data.index + 1 }}
      </template>

      <template v-slot:cell(meterAccount)="data">
        {{ data.item.meterAccountLabel }}
      </template>

      <template v-slot:cell(currentUsage)="data">
        {{ Number(data.item.currentUsage || 0).toFixed(4) }}
      </template>

      <template v-slot:cell(measurementUnit)="data">
        {{ data.item.measurementUnitLabel }}
      </template>

      <template v-slot:cell(currentCost)="data">
        {{ formatAmount(data.item.currentCost) }}
      </template>

      <template v-slot:cell(attachList)="data">
        <div style="color: #4caedc" v-for="(file,index) in data.item.attachList" :key="index" @click="$viewAttach(file)">{{ file.name }}</div>
      </template>

      <template v-slot:cell(remarks)="data">
        <div style="color: #4caedc" @click="showDetail(data.item.remarks)">{{ data.item.remarks }}</div>
      </template>

      <template v-slot:table-colgroup="scope">
        <col
            v-for="field in scope.fields"
            :key="field.key"
            :style="{ width: field.width }"
        >
      </template>
    </b-table>
  </div>
</template>

<script>
import QueryInfoService from "@/api/system/queryInfoService";

export default {
  name: "ApmsRegUtilityBillDetail",
  data() {
    return {
      fields1: [
        {key: 'index', stickyColumn: true, label: '序号', width: '55px'},
        {key: 'meterAccount', label: '计量表', width: '220px'},
        {key: 'currentUsage', label: '本期用量', width: '130px'},
        {key: 'measurementUnit', label: '单位', width: '130px'},
        {key: 'currentCost', label: '本期费用（元）', width: '140px'},
        {key: 'attachList', label: '附件', width: '190px'},
        {key: 'remarks', label: '备注', width: '150px'},
      ],
      items: [],
    }
  },
  created() {
    const data = this.$route.query.data
    if (data) {
      this.items = JSON.parse(data)
      this.updateDictNames(this.items, {
        apms_utility_meter_account: 'meterAccount',
        apms_utility_measurement_unit: 'measurementUnit',
      })
    }
  },
  methods: {
    goBack() {
      this.$router.back()
    },
    formatAmount(value) {
      const num = Number(value)
      if (isNaN(num)) {
        return '0.00'
      }
      return num.toFixed(2)
    },
    showDetail(content) {
      if (!content) {
        return
      }
      this.$dialog.alert({
        message: content,
        confirmButtonColor: '#409EFF'
      })
    },
    async updateDictNames(dataList, dictTypeList) {
      const {data} = await new QueryInfoService().getDictMap();
      dataList.map((item) => {
        for (const [dictType, formField] of Object.entries(dictTypeList)) {
          if (data[dictType] && Array.isArray(data[dictType])) {
            const dictItem = data[dictType].find(d => d.value === item[formField]);
            if (dictItem) {
              this.$set(item, `${formField}Label`, dictItem.label);
            }
          }
        }
      });
    },
  }
}
</script>

<style scoped>
</style>
